// Module
var code = "<iframe src=\"{{vm.getFrameUrl()}}\" height=\"{{vm.height}}\" width=\"{{vm.width}}\" frameborder=\"0\" scrolling=\"no\"></iframe> ";
// Exports
module.exports = code;